import React, { FC } from "react";

import { AddLocation, CameraEnhance, Map, Settings } from "@mui/icons-material";
import {
  IconButton,
  Theme,
  Tooltip,
  useMediaQuery,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { NavLink } from "react-router-dom";

import { useSidebar } from "@/contexts/SidebarContext";

import { collapsedAppIconSx } from "./collapsedAppIconSx";
import { frameNavItemSx } from "./frameNavItemSx";

interface Props {
  dense: boolean;
  logout: () => void;
  onMenuClick: () => void;
}

const RubiCanvasMenu: FC<Props> = () => {
  const theme = useTheme();
  const isSmall = useMediaQuery((theme as Theme).breakpoints.down("sm"));
  const { collapsed, setCollapsed } = useSidebar();

  const hideSideBar = () => {
    setCollapsed(true);
  };

  const menuItems = [
    {
      to: "/rubicanvas/map",
      text: "Map",
      icon: <Map />,
    },
    {
      to: "/rubicanvas/add-camera",
      text: "Add Camera",
      icon: <AddLocation />,
    },
    {
      to: "/rubicanvas/settings",
      text: "Settings",
      icon: <Settings />,
    },
  ];

  return (
    <div className="menu">
      {!collapsed ? (
        <div className="sidebar-top">
          <div className="app-name">
            Rubi<span>CANVAS</span>{" "}
            {/* <Chip
              size="small"
              label="Alpha"
              sx={{ bgcolor: "white", color: "black" }}
            /> */}
          </div>
        </div>
      ) : (
        <>
          <div className="application-item">
            <Tooltip title="Camera Registry" placement="right" arrow>
              <IconButton
                aria-label="RubiCanvas App"
                size="large"
                disableRipple
                sx={collapsedAppIconSx}
              >
                <CameraEnhance />
              </IconButton>
            </Tooltip>
          </div>
        </>
      )}
      <div className="left-menu">
        {" "}
        {menuItems.map((item) => (
          <MenuItem
            key={item.to}
            component={NavLink}
            to={item.to}
            onClick={isSmall ? hideSideBar : undefined}
            sx={[
              frameNavItemSx(),
              {
                pl: 2,
                py: 1.5,
              },
            ]}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
            {!collapsed && <ListItemText primary={item.text} />}
          </MenuItem>
        ))}
      </div>
    </div>
  );
};

export default RubiCanvasMenu;
